module.exports = require("babel-runtime/helpers/asyncToGenerator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/asyncToGenerator"
// module id = 20
// module chunks = 0